import React, { useEffect, useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import { TextDisplayCard } from 'components/TextDisplayCard/TextDisplayCard'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import {
  Flex,
  Separator,
  PageWrapper,
  H1WithBack,
  ItemsGrid,
} from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { clearInventoryField, getSingleInvField } from 'features/inventory/invSettingsFieldsSlice'
import { OtherText, TitleText } from 'styling/Typography'
import { fieldTypes } from 'components/Modal/FieldsModal'
import { IInventoryFieldsModal, InventoryFieldsModal } from './InventoryFieldsModal'

export const SingleInvField = () => {
  const [modal, setModal] = useState({ open: false, value: null })
  const dispatch = useDispatch<AppDispatch>()
  const { singleField, noSubfields } = useSelector((store: RootState) => store.invSettingsFields)
  const { id } = useParams()

  useEffect(() => {
    dispatch(getSingleInvField(Number(id)))
    return () => {
      dispatch(clearInventoryField())
    }
  }, [])

  const dataTypes = ['Text', 'Number', 'DropDown']

  const convertDataForModal = (): IInventoryFieldsModal => {
    return {
      id: Number(id),
      label: singleField?.label,
      helpText: singleField?.helpText,
      dataType: fieldTypes.find(t => t.value == singleField?.dataType),
      dropDownItems: singleField?.dropDownItems?.map(i => ({ id: Number(i.id), name: i.name, type: fieldTypes.find(t => t.value == i.dataType) })),
      unit: singleField?.unit ? { value: singleField?.unit?.id, label: singleField?.unit.name } : null,
    }
  }


  return (
    <>
      <NavBar />
      <PageWrapper>
        <Flex between center>
          <H1WithBack title={singleField?.label} arrow />
          <Button variant='primary' onClick={() => setModal({ open: true, value: convertDataForModal() })}>
            Edit Field
          </Button>
        </Flex>
        <Separator />
        <Flex mb='16'>
          <TitleText weight='bold'>Field</TitleText>
        </Flex>
        <Flex gap='1rem' center>
          {singleField?.unit?.name && (
            <TextDisplayCard title={singleField?.unit?.name} labelText='Field unit' />
          )}
          <TextDisplayCard title={dataTypes[singleField?.dataType - 1]} labelText='Data type' />
        </Flex>
        <Flex gap='1rem' m='2rem 0' column>
          <TitleText weight='bold'>Subfields</TitleText>
          {!noSubfields ? (
            singleField?.dropDownItems?.map((item) => {
              return (
                <ItemsGrid columns={2} gap='1rem' key={item.id} width='60%'>
                  <TextDisplayCard labelText='Value' title={item.name} />
                  <TextDisplayCard labelText='Data type' title={dataTypes[item.dataType - 1]} />
                </ItemsGrid>
              )
            })
          ) : (
            <OtherText>No Subfields</OtherText>
          )}
        </Flex>
      </PageWrapper>
      {modal?.open && <InventoryFieldsModal closeModal={() => setModal({ open: false, value: modal.value })} value={convertDataForModal()} />}
    </>
  )
}
